
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  --layout-gap:var(
    --sic-card-grid--layout-gap,
    var(--sic-card-grid--default--layout-gap)
  );
  --sic-body-text--font-size:var(--body-03-font-size);
  --sic-body-text--line-height:var(--body-03-line-height);
}

.content{
  font-size:var(--sic-card-grid--default--font-size);
  font-size:var(
    --sic-card-grid--font-size,
    var(--sic-card-grid--default--font-size)
  );
  line-height:var(--sic-card-grid--default--line-height);
  line-height:var(
    --sic-card-grid--line-height,
    var(--sic-card-grid--default--line-height)
  );
}

.body{
  padding-block-start:var(--sic-card-grid--default--body-spacing);
  padding-block-start:var(
    --sic-card-grid--body-spacing,
    var(--sic-card-grid--default--body-spacing)
  );
}

.cta{
  padding-block-start:var(--sic-card-grid--default--cta-spacing);
  padding-block-start:var(
    --sic-card-grid--cta-spacing,
    var(--sic-card-grid--default--cta-spacing)
  );
}

.content{
  padding-bottom:var(--spacing-08);
}

@media (min-width: 1024px){
  .container{
    display:grid;
    grid-template-columns:calc(1 / 3 * calc(100% - var(--layout-gap))) calc(
        2 / 3 * calc(100% - var(--layout-gap))
      );
    grid-template-rows:1fr;
    grid-column-gap:var(--layout-gap);
    grid-row-gap:0px;
  }
}
`;